import * as React from 'react';

import { ListView } from '@longline/aqua-ui/controls/ListView';
import { Message } from '@longline/aqua-ui/containers/Message';

import { DriverParameters, IDriverDate, IDriverset } from '../../api/models';

interface IProps {
  driverset: IDriverset | null;
}

const DriversetViewer = (props: IProps) => {
  if (!props.driverset) return null;
  return (
    <>
      <ListView
        dark
        shadow
        rowHeight={56}
        data={props.driverset.dates}
        grid
        noData={<Message.NoData margin>No drivers.</Message.NoData>}
      >
        {/* Day column */}
        <ListView.Column active name="day" label="Julian day">
          {item => item.day}
        </ListView.Column>
        {/* Parameter columns */}
        {DriverParameters.map((p, idx) => 
          <ListView.Column key={idx} active width={1} name={`p${idx}`} 
            label={`${p.label} (${p.unit})`}  
          >
            {(item: IDriverDate) => item.values[p.name] ?? '\u2014'}
          </ListView.Column>
        ) as any}
      </ListView>    
    </>
  )
}

export { DriversetViewer }

